import { useCallback } from 'react';

const useCSSTransition = ({ onEnd = () => {} } = {}) => {
  const ref = useCallback((node) => {
    const handleTransitionEnd = () => {
      onEnd();
      node.removeEventListener('transitionend', handleTransitionEnd);
    };

    if (node !== null) {
      node.addEventListener('transitionend', handleTransitionEnd);
    }
  }, []);

  return [ref];
};

export default useCSSTransition;
